import React, {Component} from 'react';
import { Container, Row, Col } from 'reactstrap';
import { sendData } from '../../analytics/sendData';
import { FormattedMessage } from 'react-intl';

class PrivacyPolicyNo extends Component {

	componentDidMount() {
        sendData('', '', '', 'viewed', { page: 'privacy-policy' });
		window.scrollTo(0, 0);
	}

	render() {

		return (

			<section className="terms privacy-policy">
				<Container fluid>
					<Row>
						<Col xs="12">
							<div className="terms-title-wrap">
								<h2 className="terms-section-title">
                                <FormattedMessage id="privacy-policy-title"
                                    defaultMessage="Privacy Policy"
                                />
                                </h2>
							</div>
						</Col>
					</Row>
					<Row className="no-gutters">
					<Col xs="12" className="terms-list">
                            <p className="terms-para">
                            Retningslinjer for personvern 
                            </p>
                            <p className="terms-para">
                            Disse retningslinjene for personvern forklarer våre forpliktelser og dine rettigheter angående dine opplysninger. Du bør lese retningslinjene for personvern nøye. Hvis du ikke er enig i disse retningslinjene for personvern, må du ikke bruke våre nettsider eller tjenester. Retningslinjene for personvern er behørig innlemmet og underlagt vilkårene for bruk, og regulerer de samme tjenestene og nettstedene som er nevnt i vilkårene for bruk. Alle uttrykk som vi bruker i retningslinjene for personvern uten å definere dem, har samme definisjon som i vilkårene for bruk.
                            </p>
                        </Col>
                        <Col xs="12" className="terms-list">
                            <h6 className="terms-title">
                            VI SAMLER INFORMASJON PÅ FØLGENDE MÅTER:
                            </h6>
                            <p className="terms-para">
                            1. Når du gir oss den eller gir oss tillatelse til å innhente den. Hvis du velger å abonnere på en tjeneste fra oss, samler vi eller mobiloperatøren av nettverket dine opplysninger knyttet til betalingen for abonnementet på tjenestene våre. Konto- og faktureringsinformasjon som er innsamlet av mobiloperatøren, er underlagt deres respektive personvernregler.
                                                     
                            </p>
                            <p className="terms-para">
                            2. Vi får teknisk informasjon når du besøker våre nettsteder og/eller tjenester. Vi kan samle inn teknisk informasjon om deg når du bruker tjenestene våre. Vi samler loggdata hver gang du logger inn på eller logger ut av tjenestene våre.
                                   
                            </p>
                        </Col>
                        <Col xs="12" className="terms-list">
                            <h6 className="terms-title">
                            HVORDAN VI BRUKER INNSAMLET INFORMASJON
                            </h6>
                            <p className="terms-para">
                            Vi kan bruke informasjon om deg til følgende formål:
                            </p>
                            <p className="terms-para">
                            Tilby tjenesten(e) du forespør:
                            </p>
                            <p className="terms-para">
                            Fakturering og innsamling for tjenesten(e) som tilbys deg     
                            </p>
                        </Col>
                        <Col xs="12" className="terms-list">
                            <h6 className="terms-title">
                            HVOR LENGE VI LAGRER INFORMASJONEN OM DEG      
                            </h6>
                            <p className="terms-para">
                            Vi beholder informasjonen om deg så lenge det er nødvendig for å kunne tilby våre tjenester til deg. Vi vil beholde informasjonen om deg etter behov for å overholde våre juridiske forpliktelser, løse tvister og håndheve avtalene våre. Når vi ikke lenger trenger å bruke informasjonen om deg, og det ikke er nødvendig for oss å beholde den for å overholde våre lovbestemte eller regulatoriske forpliktelser, sletter vi den fra våre systemer eller depersonaliserer den slik at vi ikke lenger kan identifisere deg.   
                            </p>
                           
                        </Col>
                        <Col xs="12" className="terms-list">
                            <h6 className="terms-title">
                            HVORDAN VI BESKYTTER INFORMASJON OM DEG OGSÅ UTENFOR EU    
                            </h6>
                            <p className="terms-para">
                            Vi er opptatt av å beskytte dine personlige opplysninger og data, men vi kan ikke garantere for sikkerheten til all informasjon du overfører til oss, eller garantere at informasjonen din ikke blir tilgjengelig, avslørt, endret eller ødelagt ved brudd på noen av våre fysiske, tekniske eller ledelsesmessige sikringstiltak av bransjestandard. Vi benytter passende praksis for datainnsamling, lagring og behandling og sikkerhetsforanstaltninger for å beskytte mot uautorisert eller utilsiktet tilgang, endring, avsløring eller ødeleggelse av dine opplysninger, transaksjonsinformasjon og data lagret i våre tjenester. Imidlertid er ingen metode for overføring på internett eller elektronisk lagring 100% sikker. Derfor kan vi ikke garantere absolutt sikkerhet for personlig informasjon. Vi vil fortsette å forbedre våre sikkerhetsprosedyrer etter hvert som ny teknologi blir tilgjengelig. Siden vi opererer internasjonalt, kan informasjonen om deg, inkludert personlig informasjon, overføres til og gjøres tilgjengelig i USA/Singapore og/eller et annet land enn ditt hjemland. Også i disse landene bruker vi all rimelig forsiktighet for å beskytte dine personlige opplysninger. 
                            </p>
                        </Col>
                        <Col xs="12" className="terms-list">
                            <h6 className="terms-title">
                            GODKJENNELSE AV RETNINGSLINJER FOR PERSONVERN
                            </h6>
                            <p className="terms-para">
                            Ved å bruke våre tjenester, samtykker du til vår innsamling og bruk av informasjonen om deg i samsvar med disse retningslinjene for personvern. Vi forbeholder oss retten til å endre disse retningslinjene for personvern når som helst ved å legge inn endringene på denne siden. Vennligst sjekk revisjonsdatoen nederst på denne siden for å finne ut om retningslinjene er endret siden du sist sjekket dem. Om du fortsetter å bruke hvilken som helst del av nettstedet eller tjenestene våre etter at en oppdatering retningslinjene for personvern er lagt ut, aksepterer du endringene
                            </p>
                            
                        </Col>
                        <Col xs="12" className="terms-list">
                            <h6 className="terms-title">
                            ENDRINGER AV DISSE RETNINGSLINJENE FOR PERSONVERN
                            </h6>
                            <p className="terms-para">
                            Vi kan gjøre endringer i våre retningslinjer for personvern fra tid til annen. Hvis vi bestemmer oss for å endre våre retningslinjer for personvern, vil vi legge inn disse endringene på denne siden, slik at du alltid kan få tilgang til de nyeste retningslinjene for personvern.
                               </p>
                            
                        </Col>
                        <Col xs="12" className="terms-list">
                            <h6 className="terms-title">
                            KONTAKTE OSS
                            </h6>
                            <p className="terms-para">
                            Dersom du har et spørsmål om disse retningslinjene for personvern, praksisen på nettsidene, eller din opplevelse med nettsidene, kan du kontakte oss ved å sende en e-post til info@sam-media.com.
                            </p>
                            
                        </Col>
					</Row>
				</Container>
			</section>

		);

	}

}

export default PrivacyPolicyNo;



// WEBPACK FOOTER //
// ./src/components/PrivacyPolicy/PrivacyPolicyNo.js